import { extendTheme } from "@chakra-ui/react";

const brandTheme = extendTheme({
  colors: {
    brand: {
        50: "#e3f6e8", // Lightest shade
        100: "#b3e1b3", // Light shade
        200: "#81cc81", // Medium light shade
        300: "#4fb74f", // Medium shade
        400: "#3cae3c", // Slightly darker
        500: "#2f9b2f", // Dark shade
        600: "#238b23", // Darker shade
        700: "#1c6e1c", // Even darker shade
        800: "#155215", // Very dark shade
        900: "#0d3a0d", // Darkest shade
    },
  },
});

export default brandTheme;